import { writable } from 'svelte/store';
// import { browser } from '$app/environment';

function persisted(key, defaultValue) {
    const initialValue = localStorage ? localStorage.getItem(key) : null;
    const parsedInitialValue = initialValue ? initialValue : defaultValue;

    const store = writable(parsedInitialValue);

    store.subscribe(value => {
        //if (browser) {
            localStorage.setItem(key, value);
        //}
    });

    return store;
}

const SelectedGender = persisted("genderMode","m");

export default SelectedGender;